











import { Component, Vue } from 'vue-property-decorator';
import aboutText from '../assets/about.md';
import { render } from 'slimdown-js';

@Component({
  components: {},
})
export default class AboutView extends Vue {
  private getMarkdown(): string {
    const text = aboutText;
    const r = render(text, true);
    console.log(r);
    return r;
  }

  mounted(): void {
    console.log(`AboutView mounted`);
  }
}
